import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../store";
import { getIsLoggedIn, getIsSuperAdmin } from "../../store/slices/auth/auth.slice";

const AdminRoute = () => {
	const isLoggedIn = useAppSelector(getIsLoggedIn);
	const isSuperAdmin = useAppSelector(getIsSuperAdmin);

	return isLoggedIn && isSuperAdmin ? <Outlet /> : <Navigate to={"/"} replace />;
};

export default AdminRoute;
